import React from 'react';

import { useAuth } from 'context/Auth';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';

import { PFLEGENDE_BU, PFLEGENDE_BU_ID_TO_NAME } from 'global/constants';

import { logoutWithRedirect } from 'utils/AuthUtils';
import { getBUEmail, getTenantIdByBU } from 'utils/tenantUtil';

export const SiteBlockedModal = ({ installer }) => {
  const { isCIAM } = useAuth();
  const tenantId = getTenantIdByBU(installer.pflegendeBu);
  const buName = PFLEGENDE_BU_ID_TO_NAME[installer.pflegendeBu] || '';
  const buEmail = getBUEmail(tenantId);

  return (
    <CustomModal
      isOpen
      title="Eintragung gelöscht"
      content={
        <div className="home-page__deleted-profile-text">
          <div>
            Ihre Eintragung im Installateurverzeichnis ist gelöscht. Für eine erneute Aktivierung
            Ihrer Eintragung im gemeinsamen Installateurverzeichnis, senden Sie bitte eine
            E-Mail-Nachricht an {buName} <br />
            <a className="link generic-info__link" href={`mailto:${buEmail}`}>
              {buEmail}
            </a>
          </div>
        </div>
      }
      ctaButtons={
        <ActionButton
          inverted
          onClick={() => {
            logoutWithRedirect(isCIAM);
          }}
          title="Zurück zum Login"
        />
      }
    />
  );
};
